import { useEffect, useState } from "react";
import { fetchDevices } from "utils/gatewayFunctions";
import { GatewayDeviceList } from "types/Gateways";

type UseAllDevicesParams = {
    // Default to true, fetch devices on mount
    shouldFetch?: boolean;
};

export const useAllDevices = ({ shouldFetch = true }: UseAllDevicesParams) => {
    const [devices, setDevices] = useState<GatewayDeviceList | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const allRegistries = devices ? devices.allRegistry : null;
    const allDevices = devices ? devices.deviceList : null;

    useEffect(() => {
        if (!shouldFetch) {
            return;
        }

        fetchDevices()
            .then((devices) => setDevices(devices))
            .finally(() => setIsLoading(false));
    }, [shouldFetch]);

    return { allRegistries, allDevices, isLoading };
};
